module.exports = "<div class=\"pagination-bar__wrapper\">\n  <span class=\"icon left-arrow\" ng-click=\"vm.canGoToPreviousPage() && vm.previousPage()\"></span>\n  <span ng-repeat=\"pageNumber in vm.displayedPageNumbers\" ng-class=\"{ 'pagination-bar__selected': vm.isSelected(pageNumber) }\"><a href=\"#\" ng-click=\"vm.setPageNumber(pageNumber)\">{{pageNumber}}</a></span>\n  <span class=\"icon right-arrow\" ng-click=\"vm.canGoToNextPage() && vm.nextPage()\"></span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./app/components/paginationBar/paginationBar.html
// module id = 361
// module chunks = 1